/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {ElGordosRevengeGameAssets} from "./ElGordosRevengeGameAssets";
import {ElGordosRevengeSound} from "./sound/ElGordosRevengeSound";
import {ElGordosRevengeBackground} from "./view/ElGordosRevengeBackground";
import {ElGordosRevengeWinPresentation} from "./gameflow/ElGordosRevengeWinPresentation";
import {ElGordosRevengeNormalBetPresentation} from "./gameflow/ElGordosRevengeNormalBetPresentation";
import {ElGordosRevengeNormalResultPresentation} from "./gameflow/ElGordosRevengeNormalResultPresentation";
import {ElGordosRevengeNormalIdlePresentation} from "./gameflow/ElGordosRevengeNormalIdlePresentation";
import {ElGordosRevengeModel} from "./server/ElGordosRevengeModel";
import {ElGordosRevengeLayers} from "./view/ElGordosRevengeLayers";
import {ElGordosRevengeReelController} from "./reels/ElGordosRevengeReelController";
import {ElGordosRevengeGameConfig} from "./ElGordosRevengeGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {SymbolLandingController} from "./reelstoppresentation/presentations/SymbolLandingController";
import {S1LandingController} from "./reelstoppresentation/presentations/S1LandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {WildNudgeController} from "./winpresentation/presentations/WildNudgeController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {ElGordosRevengeFreespinIdlePresentation} from "./gameflow/ElGordosRevengeFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {WaysWonCountUp} from "./winpresentation/presentations/initial/WaysWonCountUp";
import {SymbolWinHighlightController} from "./reelstoppresentation/presentations/SymbolWinHighlightController";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {EGRLastReelController} from "./reels/EGRLastReelController";
import {XBetController} from "./xbet/XBetController";
import {Multiplier} from "./view/Multiplier";
import {Ways} from "./view/Ways";
import {ShootingScreen} from "./view/shooting/ShootingScreen";
import {XRipController} from "./winpresentation/presentations/XRipController";
import {DisableLastReelController} from "./winpresentation/presentations/DisableLastReelController";
import {EGRWinView} from "./winpresentation/WinView";
import {FreespinUpgradeController} from "./winpresentation/presentations/FreespinUpgradeController";
import {S1ToWRSTransformController} from "./winpresentation/presentations/S1ToWRSTransformController";
import {ReelSplitController} from "./winpresentation/presentations/ReelSplitController";
import {CylinderController} from "./winpresentation/presentations/CylinderController";
import {FSMeter} from "./view/FSMeter";
import {CollectBonusController} from "./winpresentation/presentations/CollectBonusController";
import {LastReelFSLandingController} from "./reelstoppresentation/presentations/LastReelFSLandingController";
import {NearWinView} from "./view/NearWinView";
import {XBetView} from "./reelstoppresentation/presentations/XBetView";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class ElGordosRevenge extends SlotGame {
    public static model:ElGordosRevengeModel;
    public static gameFlowController:GameFlowController;
    public static assetLoader:AssetLoader;
    public static background:ElGordosRevengeBackground;
    public static xBetView:XBetView;
    public static xBetController:XBetController;
    public static reels:ElGordosRevengeReelController[];
    public static reelStopPresentations:ReelStopPresentationManager;
    public static winPresentations:WinPresentationManager;
    public static multiplier:Multiplier;
    public static initialCountUp:InitialWinCountUp;
    public static bigWinCountUp:BigWinCountUp;
    public static ways:Ways;
    public static waysWon:WaysWonCountUp;
    public static individualWin:IndividualWinController;
    public static freespinIntro:FreespinIntro;
    public static freespinOutro:FreespinOutro;
    public static winCapScreen:WinCapScreen;
    public static shootingScreen:ShootingScreen;
    public static winView:EGRWinView;
    public static cylinderController:CylinderController;
    public static fsMeter:FSMeter;
    public static scatters:S1LandingController;
    public static nearWinView:NearWinView;

    public static playScattersWin:boolean = false;
    public static isSpinning:boolean = false;

    public static isActionSpinsActive:boolean = false;

    private skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady() : Promise<any>{
        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            //Bonus
            replaceMap.set("BOOSTED_BET_1", "BOOSTED_BET_1.png");
            replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");
            replaceMap.set("BOOSTED_BET_3", "BOOSTED_BET_3.png");
            replaceMap.set("BOOSTED_BET_4", "BOOSTED_BET_4.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    public async init():Promise<NolimitPlugin> {
        const value = await super.init();

        if(NolimitConfig.isDevMode) {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
        }
        (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;

        ElGordosRevengeGameConfig.updateReelSets();
        ElGordosRevenge.model = new ElGordosRevengeModel(SlotGame.apiPlugin, true);
        ElGordosRevenge.gameFlowController = new GameFlowController(SlotGame.apiPlugin, ElGordosRevenge.model);
        ElGordosRevenge.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        const normalIdle = new ElGordosRevengeNormalIdlePresentation();
        const normalBet = new ElGordosRevengeNormalBetPresentation();
        const normalResult = new ElGordosRevengeNormalResultPresentation();
        const winPres = new ElGordosRevengeWinPresentation();
        const freespinIdle = new ElGordosRevengeFreespinIdlePresentation();

        ElGordosRevenge.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, normalIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        ElGordosRevenge.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        ElGordosRevenge.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        this.handleSweepInit();
        return value;
    }


    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "bonus/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            resolve(paytableString);
        });
    }

    public async getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(ElGordosRevengeGameAssets.RESOURCES_GROUPS);
        ElGordosRevenge.assetLoader = new AssetLoader(SlotGame.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), ElGordosRevenge.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);
        await this.createViewsAndComponents();
        return value;
    }

    public async getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        ElGordosRevengeSound.switchMusic(
            {name : ElGordosRevengeSound.MAIN_GAME_MUSIC, volume : 0},
            {name : ElGordosRevengeSound.MAIN_GAME_MUSIC, from : 0, to : 1, duration : 500}
        );

        return await super.getReadyToStart();
    }

    public async start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.

        const value = await super.start();

        this.restoreKeypadWin();
        ElGordosRevenge.gameFlowController.start();
        // ElGordosRevengeSound.switchMusic({name : ElGordosRevengeSound.getMusicNameByMode(ElGordosRevenge.model.data.mode)});

        return value;
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new ElGordosRevengeSound();
        const layers = new ElGordosRevengeLayers();

        //Views
        ElGordosRevenge.shootingScreen = new ShootingScreen();
        ElGordosRevenge.background = new ElGordosRevengeBackground();
        ElGordosRevenge.xBetController = new XBetController();
        ElGordosRevenge.waysWon = new WaysWonCountUp();
        ElGordosRevenge.initialCountUp = new InitialWinCountUp();
        ElGordosRevenge.bigWinCountUp = new BigWinCountUp(new PIXI.Point(360, 410));
        ElGordosRevenge.freespinIntro = new FreespinIntro();
        ElGordosRevenge.freespinOutro = new FreespinOutro();
        ElGordosRevenge.winCapScreen = new WinCapScreen();
        ElGordosRevenge.nearWinView = new NearWinView();
        ElGordosRevenge.fsMeter = new FSMeter();
        // ElGordosRevenge.fsMeter.show();
        ElGordosRevenge.reels = [
            new ElGordosRevengeReelController(0),
            new ElGordosRevengeReelController(1),
            new ElGordosRevengeReelController(2),
            new ElGordosRevengeReelController(3),
            new ElGordosRevengeReelController(4),
            new EGRLastReelController()
        ];
        ElGordosRevenge.scatters = new S1LandingController();
        ElGordosRevenge.xBetView = new XBetView();
        ElGordosRevenge.reelStopPresentations = new ReelStopPresentationManager([
            new ReelStopSoundController(),
            new SymbolLandingController(),
            ElGordosRevenge.scatters,
            new SymbolWinHighlightController(),
            new LastReelFSLandingController(),
            ElGordosRevenge.xBetView
        ]);
        ElGordosRevenge.cylinderController = new CylinderController();
        ElGordosRevenge.winView = new EGRWinView();
        ElGordosRevenge.multiplier = new Multiplier();
        ElGordosRevenge.ways = new Ways();
        ElGordosRevenge.winPresentations = new WinPresentationManager([
            new DisableLastReelController(),
            new WildNudgeController(),
            new CollectBonusController(),
            new S1ToWRSTransformController(),
            new ReelSplitController(),
            ElGordosRevenge.cylinderController,
            new NoWinSymbolsController(),
            new XRipController(),
            new InitialWinController(),
            new BigWinController(),
            new FreespinWinController(),
            new FreespinUpgradeController(),
            new FreespinEndController(),
            new BreakBankController()
        ]);
        ElGordosRevenge.individualWin = new IndividualWinController();

        // If restore, can be handled in these constructors directly.
    }

    private restoreKeypadWin():void {
        if(ElGordosRevenge.model.isRestore) {
            if(ElGordosRevenge.model.restoredFeatureBetName && ElGordosRevenge.model.restoredFeatureBetName.length > 0) {
                const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
                if(!activeBetFeature) {
                    SlotGame.apiPlugin.betFeatureController.setActiveBetFeature(ElGordosRevenge.model.restoredFeatureBetName);
                    const newActiveBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
                    // if(newActiveBetFeature) {
                    //     Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():new set to api feature bet name = ${newActiveBetFeature.name}`);
                    // }else {
                    //     Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():fail to set api feature bet name to = ${TombstoneRip.model.restoredFeatureBetName}`);
                    // }
                } else {
                    // Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():api feature bet name = ${activeBetFeature.name}`);
                }
            }
            if(ElGordosRevenge.model.parsedInitData.showTotalWin) {
                SlotGame.keypadPlugin.setWin(ElGordosRevenge.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
            }
        }
    }

    getNoWinGameData():any {
        return {
            "accumulatedRoundWin" : 0,
            "betWayWins" : [],
            "boostedBetPlayed" : false,
            "brokeTheBank" : false,
            "cylinderContent" : [],
            "evaluatedArea" : [
                ['M3', 'M2'],
                ['M3', 'M3', 'M3'],
                ['L5', 'L2', 'L2'],
                ['M3', 'L5', 'L4'],
                ['L4', 'L4', 'L4'],
                ['M4', 'M4']
            ],
            "featureBuyName" : "NORMAL_PLAY",
            "freespinTriggeredThisSpin" : false,
            "freespinsLeft" : 0,
            "mode" : "NORMAL",
            "multiplierOnReels" : [0, 0, 0, 0, 0, 0],
            "nextMode" : "NORMAL",
            "numberOfFreespinsPlayed" : 0,
            "playedBetValue" : 1,
            "reels" : [
                ['L4', 'M3', 'M2', 'M5'],
                ['L1', 'M3', 'M3', 'M3', 'M5'],
                ['L5', 'L5', 'L2', 'L2', 'M3'],
                ['M3', 'M3', 'L5', 'L4', 'L4'],
                ['L1', 'L4', 'L4', 'L4', 'L2'],
                ['M3', 'M4', 'M4', 'M5']
            ],
            "symbolSizes" : [
                [1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1]
            ],
            "totalSpinWinnings" : 0,
            "wasFeatureBuy" : false,
            "xRip" : false
        };
    }
}